import { useParams } from 'react-router-dom';

import TokensOverview from '../../features/tokens/layouts/overview';
import IssueTokenForm from '../../features/tokens/forms/issue';

// TSS vite/01 §"Pages are thin" — read the URL, mount a feature.
//
// There is no edit route and there is no detail route: a token is not a record
// somebody maintains, it is a credential. It gets issued, listed and revoked.

export default function TokensPage({ mode }) {
    const { id } = useParams();

    if (mode === 'create' || id === 'new') return <IssueTokenForm />;
    return <TokensOverview />;
}
